<template>
  <div id="top">
    <v-container>
      <h2>簡易版・符計算</h2>
      <v-row>
        <v-btn class="white--text" color="blue darken-1" :to="{ name: 'easy' }"
          >超簡易な符計算を覚える</v-btn
        >
      </v-row>
      <h2>符計算マスター</h2>
      <v-row>
        <v-btn class="white--text" color="blue darken-2" :to="{ name: 'kotsu' }"
          >刻子の符を覚える</v-btn
        >
      </v-row>
      <v-row>
        <v-btn class="white--text" color="blue darken-3" :to="{ name: 'mati' }">
          雀頭・待ち・アガリの符を覚える</v-btn
        >
      </v-row>
      <v-row>
        <v-btn class="white--text" color="blue darken-4" disabled>高速化を身に付ける</v-btn>
      </v-row>
      <h2>点数マスター</h2>
      <v-row>
        <v-btn class="white--text" color="pink lighten-3" :to="{ name: 'sheet' }"
          >点数表を覚える</v-btn
        >
      </v-row>
      <v-row>
        <v-btn class="white--text" color="pink lighten-2" disabled>実際の手牌で計算する</v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "top",
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.container {
  .row {
    margin: 1rem;
    .v-btn {
      width: 100%;
    }
  }
}
</style>
